module.exports = __webpack_public_path__ + "img/logo_apvs_brasil.b9ef03f5.png";